<div class="modal-content">
    <h1 mat-dialog-title>
        Confirm Navigation
    </h1>
    <div mat-dialog-content class="dialog-content">
        <p>
            <b>Are you sure you want to leave this page?</b>
        </p>
        <p>
            Changes on this page will not be saved. <br/>
            By continuing, you will be logged out of the form.
        </p>
    </div>
    <div class="action-button-container" mat-dialog-actions align="end">
        <button id="unsave-dialog-stay" mat-raised-button color="accent" (click)="OnStay()">
            Stay on this page
        </button>
        <button id="unsave-dialog-leave" mat-raised-button color="primary" (click)="OnLeave()">
            Leave this page
        </button>
    </div>
</div>
<br>
